const beaAttachmentsStyles = {
  button: { margin: "1rem auto", width: 300, display: "block", textAlign: "center" },
};
export default beaAttachmentsStyles;
